import Vue from 'vue';

import { RoomType } from '@/openapi/enum';
import { RoomResponse } from '@/openapi/common';

import { ROOM, USER_STORAGE_KEY } from '@/classes/common/Constants';
import StorageUtility from '@/classes/common/StorageUtility';
import UserApiUtility from '@/classes/common/UserApiUtility';

type State = {
  id: string | null;
  type: RoomType | null;
};

const state = Vue.observable<State>({
  id: null,
  type: null,
});

export default Vue.extend({

  name: 'RoomMixin',

  computed: {
    isNormal(): boolean {
      return this.$_isStateRoomType(RoomType.normal);
    },
    isManabi(): boolean {
      return this.$_isStateRoomType(RoomType.manabi);
    },
    isGoogle(): boolean {
      return this.$_isStateRoomType(RoomType.google);
    },
    isBespra(): boolean {
      return this.$_isStateRoomType(RoomType.bespra);
    },
    isDemo(): boolean {
      return state.id === ROOM.ID.DEMO;
    },
    roomId(): string {
      return state.id ?? '';
    },
    resourceName(): string {
      switch (state.type) {
        case RoomType.normal: return 'normal';
        case RoomType.manabi: return 'manabi';
        case RoomType.google: return 'google';
        case RoomType.bespra: return 'bespra';
        default:              return '';
      }
    },
  },

  methods: {
    async setRoomState(roomId: string): Promise<void> {
      // css等を出しわけるため、教室IDに紐づく組織を取得し、教室種別を設定
      const response = await UserApiUtility.getRoomApi().showRoom(roomId);
      state.id   = roomId;
      state.type = response.data.roomType;

      StorageUtility.setLocalData<string>(USER_STORAGE_KEY.ROOM_ID, state.id);
      StorageUtility.setLocalData<RoomType>(USER_STORAGE_KEY.ROOM_TYPE, state.type);
    },
    // ログイン画面以外でリロードした時に呼び出される
    loadRoomState(): void {
      state.id   = StorageUtility.getLocalData<string>(USER_STORAGE_KEY.ROOM_ID);
      state.type = StorageUtility.getLocalData<RoomType>(USER_STORAGE_KEY.ROOM_TYPE);
    },
    $_isStateRoomType(type: RoomType): boolean {
      return state.type !== null ? state.type === type : false;
    },
  }

});
